export const USER_CARD_ENUM = {
  NAME_CARD: "NAME_CARD",
  EMAIL_CARD: "EMAIL_CARD",
  PHONE_CARD: "PHONE_CARD",
  GENDER_CARD: "GENDER_CARD",
  BIRTHDAY_CARD: "BIRTHDAY_CARD",
  ADRESS_CARD: "ADRESS_CARD",
  GOVERNMENT_ID_CARD: "GOVERNMENT_ID_CARD",
};

export const UPLOAD_RESOURCES = {
  PERSON: "PERSON",
};

export const UPLOAD_TYPES = {
  PHOTO: "PHOTO",
};
